import AppEnvironment from '../../environment/app-environment';

export abstract class AuthServiceBase {
  public readonly MEM_AUTH_SCOPE = `${AppEnvironment.tokenAuthorithySelexp}`;

  public readonly GRAPH_AUTH_SCOPE = `${AppEnvironment.tokenAuthorithyGraph}`;

  public abstract getTokenForScope(scope: string): Promise<string>;

  public abstract getAccountInfo(): Promise<any>;
}
